import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import { map } from 'lodash';
import { Panel } from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import TableUtils from '../../../../../utils/TableUtils';
import TablePlain from '../../../../../components/table-plain/TablePlain';
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelVinculos extends React.Component {

    onRequestInfo = (infoKey, infoTitle) => {
        this.props.onRequestInfo(lstrings.vinculos_title, infoTitle);
    }

    render() {
        let titulo = <h2><i className="fa fa-share-alt"></i> {lstrings.vinculos_title}</h2>;

        return (
            <ScrollableAnchor id={'panel-vinculos'}>
                <Panel collapsible defaultExpanded header={titulo}>
                    <PermissionChecker infoKey='vinculos' infoTitle='Vínculos familiares' data={this.props.info.vinculos}
                        onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}>
                        {this.props.info.vinculos && <TablePlain columns={["DNI/CUIT", "Nombre", "Parentesco", "Sexo"]}
                            rows={map(this.props.info.vinculos.datos, (item, ix) => <tr key={ix}>
                                <td>{TableUtils.cuilFormat(item.cuilVinculo)}</td>
                                <td>{item.nombre}</td>
                                <td>{item.relacion}</td>
                                <td>{item.sexo}</td>
                            </tr>)} />}
                    </PermissionChecker>

                    <PermissionChecker infoKey='otrosVinculos' infoTitle='Otros vínculos' data={this.props.info.otrosVinculos}
                        onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}>
                        {this.props.info.otrosVinculos && <TablePlain columns={["DNI/CUIT", "Nombre"]}
                            rows={map(this.props.info.otrosVinculos.datos, (item, ix) => <tr key={ix}>
                                <td>{TableUtils.cuilFormat(item.cuilvinculo)}</td>
                                <td>{item.nombre}</td>
                            </tr>)} />}
                    </PermissionChecker>
                </Panel>
            </ScrollableAnchor>
        );
    }
}

PanelVinculos.propTypes = {
    info: PropTypes.any.isRequired,
    onRequestInfo: PropTypes.func.isRequired,
    hidePanels: PropTypes.any    
};

export default PanelVinculos;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelVinculos.js